/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPINDUSTRY } from './IAPINDUSTRY';
import {
    IAPINDUSTRYFromJSON,
    IAPINDUSTRYFromJSONTyped,
    IAPINDUSTRYToJSON,
} from './IAPINDUSTRY';
import type { IAPINDUSTRYSECTOR } from './IAPINDUSTRYSECTOR';
import {
    IAPINDUSTRYSECTORFromJSON,
    IAPINDUSTRYSECTORFromJSONTyped,
    IAPINDUSTRYSECTORToJSON,
} from './IAPINDUSTRYSECTOR';
import type { IAPSOURCEOFWEALTH } from './IAPSOURCEOFWEALTH';
import {
    IAPSOURCEOFWEALTHFromJSON,
    IAPSOURCEOFWEALTHFromJSONTyped,
    IAPSOURCEOFWEALTHToJSON,
} from './IAPSOURCEOFWEALTH';

/**
 * 
 * @export
 * @interface FinancialInformationViewModel
 */
export interface FinancialInformationViewModel {
    /**
     * 
     * @type {Array<IAPSOURCEOFWEALTH>}
     * @memberof FinancialInformationViewModel
     */
    sourcesOfWealth?: Array<IAPSOURCEOFWEALTH>;
    /**
     * 
     * @type {string}
     * @memberof FinancialInformationViewModel
     */
    otherSourceOfWealthDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialInformationViewModel
     */
    businessActivity?: string;
    /**
     * 
     * @type {IAPINDUSTRYSECTOR}
     * @memberof FinancialInformationViewModel
     */
    industrySectorId?: IAPINDUSTRYSECTOR;
    /**
     * 
     * @type {string}
     * @memberof FinancialInformationViewModel
     */
    industrySectorOther?: string;
    /**
     * 
     * @type {IAPINDUSTRY}
     * @memberof FinancialInformationViewModel
     */
    industryId?: IAPINDUSTRY;
    /**
     * 
     * @type {string}
     * @memberof FinancialInformationViewModel
     */
    industryOther?: string;
}

/**
 * Check if a given object implements the FinancialInformationViewModel interface.
 */
export function instanceOfFinancialInformationViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FinancialInformationViewModelFromJSON(json: any): FinancialInformationViewModel {
    return FinancialInformationViewModelFromJSONTyped(json, false);
}

export function FinancialInformationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialInformationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourcesOfWealth': !exists(json, 'SourcesOfWealth') ? undefined : ((json['SourcesOfWealth'] as Array<any>).map(IAPSOURCEOFWEALTHFromJSON)),
        'otherSourceOfWealthDescription': !exists(json, 'OtherSourceOfWealthDescription') ? undefined : json['OtherSourceOfWealthDescription'],
        'businessActivity': !exists(json, 'BusinessActivity') ? undefined : json['BusinessActivity'],
        'industrySectorId': !exists(json, 'IndustrySectorId') ? undefined : IAPINDUSTRYSECTORFromJSON(json['IndustrySectorId']),
        'industrySectorOther': !exists(json, 'IndustrySectorOther') ? undefined : json['IndustrySectorOther'],
        'industryId': !exists(json, 'IndustryId') ? undefined : IAPINDUSTRYFromJSON(json['IndustryId']),
        'industryOther': !exists(json, 'IndustryOther') ? undefined : json['IndustryOther'],
    };
}

export function FinancialInformationViewModelToJSON(value?: FinancialInformationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SourcesOfWealth': value.sourcesOfWealth === undefined ? undefined : ((value.sourcesOfWealth as Array<any>).map(IAPSOURCEOFWEALTHToJSON)),
        'OtherSourceOfWealthDescription': value.otherSourceOfWealthDescription,
        'BusinessActivity': value.businessActivity,
        'IndustrySectorId': IAPINDUSTRYSECTORToJSON(value.industrySectorId),
        'IndustrySectorOther': value.industrySectorOther,
        'IndustryId': IAPINDUSTRYToJSON(value.industryId),
        'IndustryOther': value.industryOther,
    };
}

